// extracted by mini-css-extract-plugin
export default {"button":"_2DxLlydn7Ap7MK8ldr50to","icon":"_3KiV1NPK2dWNrJxn0wHNWN","label":"_2Aq6ap08xzjSQbRjgqTWzO"};